import { Component, Input, OnInit } from '@angular/core';
import { rrssLinksComponent } from '../rrss-links/rrss-links.component';

@Component({
  selector: 'app-footer',
  standalone: true,
  templateUrl: './footer.component.html',
  imports: [rrssLinksComponent]
})
export class FooterComponent implements OnInit {

  @Input()
  public color!: string;

  public year: number = new Date().getFullYear();

  constructor() {
  }

  ngOnInit(): void {
    if (!this.color) {
      this.color = 'purple';
    }
  }

  public openLink(link: string) {
    window.open(link);
  }
}
